"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeAuthToken = exports.detectPlatform = void 0;
const types_1 = require("../types");
const isString = (x) => Object.prototype.toString.call(x) === '[object String]';
const decodeBase64 = (s) => Buffer.from(s, "base64").toString();
const detectPlatform = () => {
    const _window = typeof window !== 'undefined' ? window : {};
    if (_window.ReactNativeWebView) {
        return types_1.WebviewPlatforms.reactNative;
    }
    if (_window.webkit) {
        return types_1.WebviewPlatforms.ios;
    }
    return types_1.WebviewPlatforms.web;
};
exports.detectPlatform = detectPlatform;
const decodeAuthToken = (token) => {
    if (!isString(token)) {
        return null;
    }
    const parts = token.split('.');
    if (parts.length !== 3) {
        console.error("Invalid native auth token");
        return null;
    }
    const [_address, _body, signature] = parts;
    try {
        const address = Buffer.from(_address, "base64").toString();
        const body = Buffer.from(_body, "base64").toString();
        const loginToken = decodeLoginToken(body);
        if (!loginToken) {
            return {
                address,
                body,
                signature,
                blockHash: '',
                origin: '',
                ttl: 0
            };
        }
        return Object.assign(Object.assign({}, loginToken), { address,
            body,
            signature });
    }
    catch (e) {
        return null;
    }
};
exports.decodeAuthToken = decodeAuthToken;
const decodeLoginToken = (loginToken) => {
    const parts = loginToken.split('.');
    if (parts.length !== 4) {
        console.error('Invalid loginToken. You may be trying to decode a nativeAuthToken. ' +
            'Try using decodeNativeAuthToken method instead');
        return null;
    }
    try {
        const [origin, blockHash, ttl, extraInfo] = parts;
        const parsedExtraInfo = JSON.parse(decodeBase64(extraInfo));
        const parsedOrigin = decodeBase64(origin);
        return {
            ttl: Number(ttl),
            extraInfo: parsedExtraInfo,
            origin: parsedOrigin,
            blockHash
        };
    }
    catch (e) {
        console.error(`Error trying to decode ${loginToken}:`, e);
        return null;
    }
};
